import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"

import { enableKlarnaCheckout } from "helpers/checkout/checkout_options"

import Affirm from "./affirm"
import Klarna from "./klarna"

const InternalFinancing = ({ cartSummary, pricing, wizardLoading }) => {
  const [priceToDisplay, setPriceToDisplay] = useState(
    pricing.price_to_display || 0
  )

  useEffect(() => {
    let calculatedPrice = pricing.price_to_display || 0

    if (cartSummary) {
      calculatedPrice += cartSummary.cart_total
    }

    setPriceToDisplay(calculatedPrice)
  }, [cartSummary, pricing.price_to_display])

  if (priceToDisplay <= 0 || wizardLoading) {
    return ""
  }

  return (
    <>
      {/* US only */}
      {sl.config.enable_affirm && <Affirm />}
      {/* Non-US */}
      {sl.config.klarna_osm_pdp &&
        enableKlarnaCheckout() &&
        priceToDisplay <= sl.config.klarna_max && <Klarna />}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    cartSummary: state.cart.summary,
    pricing: state.wizardUI.currentPricing,
    wizardLoading: state.wizard.loading,
  }
}

InternalFinancing.propTypes = {
  cartSummary: PropTypes.object,
  pricing: PropTypes.object,
  wizardLoading: PropTypes.string,
}

const Financing = connect(mapStateToProps)(InternalFinancing)

export default Financing
